import { defineField, defineType } from "sanity";

export const itemBullets = defineType({
  name: "itemBullets",
  title: "Item Bullets",
  type: "document",
  description: "Bullet points displayed on item detail pages, organized by jewelry category.",
  fields: [
    defineField({
      name: "ringBullets",
      title: "Ring Bullets",
      type: "array",
      of: [{ type: "string" }]
    }),
    defineField({
      name: "earringBullets",
      title: "Earring Bullets",
      type: "array",
      of: [{ type: "string" }]
    }),
    defineField({
      name: "necklaceBullets",
      title: "Necklace Bullets",
      type: "array",
      of: [{ type: "string" }]
    }),
    defineField({
      name: "braceletBullets",
      title: "Bracelet Bullets",
      type: "array",
      of: [{ type: "string" }]
    })
  ]
});
